// extracted by mini-css-extract-plugin
export default {"title":"SubCategory_title__LSeWs","subCategoryItems":"SubCategory_subCategoryItems__s2MRu","item":"SubCategory_item__txwqu","icon":"SubCategory_icon__eIoho"};